import { render } from "./LinkShortcut.vue?vue&type=template&id=5a73f5a0"
import script from "./LinkShortcut.vue?vue&type=script&lang=js"
export * from "./LinkShortcut.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__